import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const registerPoemFilledPdfReport = async ({
  reportKind,
  blobPath,
  totalRows,
  exportRequestId,
  fileSizeBytes,
  signal,
}) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(
    `${__API_URL__}/api/reports/register_poem_filled_pdf_report/`,
    {
      report_kind: reportKind,
      blob_path: blobPath,
      total_rows: totalRows,
      study_export_request_id: exportRequestId,
      file_size_bytes: fileSizeBytes,
    },
    {
      headers: { Authorization: `Token ${token}` },
      signal,
    }
  );

  return { jobId: response.data.job_id, fileUrl: response.data.file_url };
};

export const useRegisterPoemFilledPdfReportMutation = () =>
  useMutation({
    mutationFn: ({ reportKind, blobPath, totalRows, exportRequestId, fileSizeBytes, signal }) =>
      registerPoemFilledPdfReport({
        reportKind,
        blobPath,
        totalRows,
        exportRequestId,
        fileSizeBytes,
        signal,
      }),
  });
